module.exports = "app-root {\r\n    min-width: 280px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main